export default __webpack_public_path__ + "static/media/Aadya.6205cb25.jpg";